<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Type / Loại" prop="type">
          <a-select v-model="form.type">
            <a-select-option value="HOLIDAY">
              Holiday / Nghỉ lễ
            </a-select-option>
            <a-select-option value="COMPENSATORY_LEAVE">
              Compensatory day / Nghỉ bù
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Title / Tiêu đề" prop="name">
          <a-input v-model="form.name" placeholder="Write title..." />
        </a-form-model-item>
        <a-form-model-item label="Date / Ngày nghỉ lễ" prop="rangeDate">
          <a-range-picker
            format="DD/MM/YYYY"
            style="width: 100%;"
            @change="onChangeRangeDate"
            :value="[
              moment(moment(form.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
              moment(moment(form.endDate).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
            ]"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="Năm thực hiện" prop="year">
          <a-select v-model="form.year" style="width: 100%;">
            <a-select-option v-for="item in listYears" :key="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <!-- <a-form-model-item label="Ngày bắt đầu" prop="startDate">
          <a-date-picker
            type="date"
            placeholder="Chọn ngày "
            style="width: 100%;"
            format="DD/MM/YYYY"
            :value="
              form.startDate
                ? moment(
                    moment(form.startDate).format('DD/MM/YYYY'),
                    'DD/MM/YYYY'
                  )
                : null
            "
            @change="onChangeStartDate"
          />
        </a-form-model-item>
        <a-form-model-item label="Ngày kết thúc" prop="endDate">
          <a-date-picker
            type="date"
            placeholder="Chọn ngày "
            style="width: 100%;"
            format="DD/MM/YYYY"
            :value="
              form.endDate
                ? moment(
                    moment(form.endDate).format('DD/MM/YYYY'),
                    'DD/MM/YYYY'
                  )
                : null
            "
            @change="onChangeEndDate"
          />
        </a-form-model-item> -->
        <a-form-model-item label="Duration / Số ngày nghỉ" prop="duration">
          <a-input-number
            v-model="form.duration"
            placeholder="Enter number..."
            :formatter="
              (value) =>
                +value >= 0
                  ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : undefined
            "
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            style="width: 100%;"
          />
        </a-form-model-item>

        <a-form-model-item label="Description / Mô tả">
          <VueEditor
            class="ict24h-editor"
            :editor-toolbar="customToolbar"
            placeholder="Enter description..."
            v-model="form.description"
          />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        Information
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Created by">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created at">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated at">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="Cancel"
          @confirm="onDeletedHoliday"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Close
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
import moment from "moment";
const rules = {
  type: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  name: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  duration: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  rangeDate: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  // startDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
  // endDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
};

function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const nowYear = new Date().getFullYear();
const listYears = range(+nowYear - 5, +nowYear + 5);
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idHoliday: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      moment,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      listYears,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedHoliday();
        } else {
          return false;
        }
      });
    },
    onUpdatedHoliday() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateHoliday,
          variables: {
            id: this.form.id,
            ...this.form,
            startDate: this.form.startDate
              ? moment(this.form.startDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                })
              : undefined,
            endDate: this.form.endDate
              ? moment(this.form.endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                })
              : undefined,
            year: this.form.startDate
              ? +new Date(this.form.startDate).getFullYear()
              : undefined,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
          if (data?.updateHoliday?.id) {
            this.refreshAfterUpdated(data.updateHoliday);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật thông tin không thành công", err);
        });
    },
    onGetHoliday() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDetailHoliday,
          variables: { id: this.idHoliday },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getDetailHoliday?.id) {
            this.form = { ...data.getDetailHoliday };
            if (this.form?.year) {
              this.$set(this.form, "year", this.form.year.toString());
            }
            if (this.form.startDate && this.form.endDate) {
              this.$set(this.form, "rangeDate", [
                this.form.startDate,
                this.form.endDate,
              ]);
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Lấy chi tiết thông tin không thành công", err);
        });
    },
    onDeletedHoliday() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteHoliday,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });
            this.loadingBtn = false;
            if (data?.deleteHoliday?.id) {
              this.refreshAfterDeleted(data.deleteHoliday);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Updated Error!",
            });
            console.log("Xóa thông tin không thành công", err);
          });
      }
    },
    // onChangeStartDate(value) {
    //   this.$set(this.form, "startDate", value);
    //   this.calTotalDay();
    // },
    // onChangeEndDate(value) {
    //   this.$set(this.form, "endDate", value);
    //   this.calTotalDay();
    // },
    onChangeYear(value) {
      this.$set(this.form, "year", value);
    },
    calTotalDay() {
      if (this.form.startDate && this.form.endDate) {
        const startDate = moment(this.form.startDate).set({
          hour: 0,
          minute: 0,
        });
        const endDate = moment(this.form.endDate).set({ hour: 23, minute: 59 });
        this.$set(this.form, "duration", endDate.diff(startDate, "days") + 1);
      }
    },
    onChangeRangeDate(arrayDate) {
      if (arrayDate) {
        const startDate = arrayDate[0];
        const endDate = arrayDate[1];
        this.$set(this.form, "rangeDate", arrayDate);
        this.$set(this.form, "startDate", startDate);
        this.$set(this.form, "endDate", endDate);
        this.calTotalDay();
      }
    },
  },
  created() {
    this.onGetHoliday();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
